<html>
<body class="backgroundBody">
  <div class="myContainer" style="display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;">
    <header class="header">
    </header>



    <main class = "titleBox">
            <h1 class = "frontText" style="    display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 15%;">
                Welcome <br>to <br> Raterhelper
              </h1>
              <button class="titleButton" style="display: flex;
              margin-top: 15px;
              justify-content: center;
              align-items: center;" (click)= "auth.login()" *ngIf="!auth.loggedIn"><h2 style="letter-spacing: 3px;">Login</h2></button>
    </main>





  </div><!--Container-->

 <!--
  <div class="siteFooter">
    <img width= "170" height="50" src="../assets/PerfPointLogo.png"/>
    <p class = "copyrightText">© Performance Point</p>

  </div>
-->

</body>

</html>
